import { render } from "./LotesSeleccionados.vue?vue&type=template&id=678b52a1&scoped=true"
import script from "./LotesSeleccionados.vue?vue&type=script&lang=js"
export * from "./LotesSeleccionados.vue?vue&type=script&lang=js"

import "./LotesSeleccionados.vue?vue&type=style&index=0&id=678b52a1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678b52a1"]])

export default __exports__